var map = {
	"./account.js": 9230,
	"./answer-overview.js": 17097,
	"./class-room.js": 80370,
	"./course-detail.js": 45703,
	"./course-progress.js": 32822,
	"./course.js": 80452,
	"./dashboard.js": 8911,
	"./elk-course.js": 5037,
	"./exercise-store.js": 81319,
	"./exercise.js": 72294,
	"./favorite-course.js": 79027,
	"./game-galactic-warrior.js": 39397,
	"./hanhtrangso-course.js": 93349,
	"./igiaoduc-course-detail.js": 3469,
	"./igiaoduc-course.js": 27501,
	"./learning-config.js": 68260,
	"./lesson-note.js": 30979,
	"./practice-support.js": 28880,
	"./self-learning-detail.js": 77680,
	"./self-learning.js": 30735,
	"./storage.js": 82340,
	"./student-classroom.js": 20284,
	"./student-event-calendar.js": 79079,
	"./student-exam.js": 74644,
	"./student-exercise.js": 61569,
	"./student-package-detail.js": 89857,
	"./student-package.js": 25165,
	"./student.js": 87961,
	"./submit-exam.js": 73573,
	"./survey-course.js": 37435,
	"./topic.js": 87110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21854;